
<template>
    <div class="headerPlanning">
        <!--
        <button @click="showMono(true)" class="btn btn-primary" v-if="this.$store.state.showMonoElevePage == false">Paramétrage</button>
        -->
        <button @click="showMono(false)" class="btn btn-danger" v-if="this.$store.state.showMonoElevePage == true">Planning</button>

        <!-- Rectangular switch -->
        <template v-if="this.$store.state.showMonoElevePage == false">
          <div class="header-container">
            <div class="choix-header">
                  <div class="titlePart">
                    <span>Je choisis</span>
                  </div>
                  <div class="mode">
                    <select name="monoSelect" id="" @change="changeDispoOrResa" v-model="dispoOrResa">
                      <option value="null">MODE</option>
                      <option value="false">Je définis mes dispos</option>
                      <option value="true">Je réserve mes heures</option>
                    </select>
                    <button class="btn btn-primary paramsweb" @click="openInfoResaModal"><img src="../../../assets/images/info-icon.png" alt=""></button>
                  </div>

            </div>
            <div class="headerContent">

              <div class="left">
                <!--
                <label class="switch">
                    <input type="checkbox" id="dispoResa" v-model="this.$store.state.dispoResaBtn" @click="setDispoOrResa()">
                    <span class="slider">
                        <p class="resa" v-if="this.$store.state.dispoResaBtn == true">RESA</p>
                        <p class="dispo" v-if="this.$store.state.dispoResaBtn == false">DISPO</p>
                    </span>
                </label>
                -->
                <div class="first">
                  <div class="titlePart">
                    <span>Je choisis</span>
                  </div>
                  <div class="mode">
                    <select name="monoSelect" id="" @change="changeDispoOrResa" v-model="dispoOrResa">
                      <option value="null">MODE</option>
                      <option value="false">Je définis mes dispos</option>
                      <option value="true">Je réserve mes heures</option>
                    </select>
                  </div>
                </div>

                <div class="second">
                  <div class="titlePart">
                    <span v-if="this.showBtnResa == true && this.eleve.lieuRdv.length > 1">Je réserve mes heures</span>
                    <span v-if="this.showBtnResa == true && this.eleve.lieuRdv.length <= 1">Je réserve mes heures</span>
                    <span v-if="this.showBtnResa == false">Choix de lieu de rendez-vous</span>
                    <span v-if="this.showBtnResa == 'null'">Choisissez votre mode pour continuer</span>
                  </div>
                  <div class="dispoResa" v-if="this.showBtnResa != 'null'">
                    <div v-if="this.showBtnResa == true" class="resaSelect">
                      <select name="monoSelect" id="" @change="setupMoniteurChoice" v-model="monoResa">
                        <option value="null">Choisir un moniteur</option>
                        <template v-for="m in listMonoResa" :key="m.id">
                          <option :value="m.idMono" :title="m.fullname">{{ m.surnom }}</option>
                        </template>
                      </select>
                      <button v-if="monoResa === 'null'" class="btn btn-primary paramsweb" @click="goToParams">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="3"/>
                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                        Ajouter / modifier mes moniteurs
                      </button>
                      <div v-if="monoResa !== 'null'" class="lieuAgence" style="display:inline-flex;flex-direction:row;flex-wrap:nowrap;align-items:stretch;border:1.5px solid #e2e8f0;border-radius:10px;overflow:hidden;background:#f4f6f9;">
                        <div class="lieuDeb">
                          <span class="titleLieu">DEPART</span>
                          <span class="lieuNom">{{ this.agenceLieu.nom }}</span>
                        </div>
                        <div class="lieuDeb">
                          <span class="titleLieu">ARRIVEE</span>
                          <span class="lieuNom">{{ this.agenceLieu.nom }}</span>
                        </div>
                      </div>
                      <button v-if="monoResa !== 'null'" class="btn btn-primary paramsweb" @click="goToParams">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="3"/>
                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                        Ajouter / modifier mes moniteurs
                      </button>
                    </div>
                    <div v-else class="dispoSelec">
                      <select name="dispoSelec" id="" v-model="lieuSelec" @change="changeLieuDispo">
                        <option value="">Lieu Dispo</option>
                        <template v-for="l in lieuxDispo" :key="l.id">
                          <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                        </template>
                      </select>
                      <button class="btn btn-primary paramsweb" @click="goToParams">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="3"/>
                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                        Ajouter / modifier mes lieux
                      </button>
                      <button class="btn btn-primary" @click="sendMailUpdateDispo">MAJ</button>
                      <div class="dispoMobile">
                        <template v-if="!isMobile">
                          <br>
                          <label for="">Date : </label><input type="date" name="datedispo" id="datedispo" v-model="dateDispo">
                          <label for="">Début : </label><input type="time" name="heureDebDispo" id="heureDebDispo" v-model="heureDebDispo">
                          <label for="">Fin : </label><input type="time" name="heureFinDispo" id="heureFinDispo" v-model="heureFinDispo">
                          <button class="btn btn-primary valid-mobile" @click="setupDispo" v-if="this.$store.state.loadDispoEleveBtn === false">VALIDER</button>
                          <button class="btn btn-primary valid-mobile" @click="setupDispo" v-else disabled><span><i class="fa fa-spinner fa-spin"></i>VALIDER</span></button>
                        </template>
                        <template v-else>
                          <p class="mobile-dispo-hint">Tapez sur le planning pour marquer le <strong>début</strong>, puis la <strong>fin</strong> de votre dispo</p>
                        </template>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="center">
                <div class="third">
                  <div class="mobileProg">
                    <div class="titlePart">
                      <span>Niveau de formation</span>
                    </div>
                    <button class="btn btn-primary" @click="goToTrame">{{ this.niveauEleve }}%</button>
                    <div class="heures-block">
                      <div class="titlePart">
                        <span>Nb heures à programmer</span>
                      </div>
                      <div class="heure-equation">
                        <div class="heure-box heure-box-clickable" @click="showTrameDialog = true">
                          <span class="heure-box-value">{{ eleve.heureRestanteTrame }}h</span>
                          <span class="heure-box-label">H pour finir la formation</span>
                        </div>
                        <span class="heure-op">-</span>
                        <div class="heure-box heure-box-clickable" @click="showHeuresProgrammeesDialog = true">
                          <span class="heure-box-value">{{ heureProgrammees }}h</span>
                          <span class="heure-box-label">{{ heureProgrammeesLabel }}</span>
                        </div>
                        <span class="heure-op">=</span>
                        <div class="heure-box heure-box-highlight">
                          <span class="heure-box-value">{{ eleve.heureAProg }}h</span>
                          <span class="heure-box-label">H à programmer</span>
                        </div>
                        <button @click="showAccDiag()" class="btn btn-danger accActiv" v-if="acc == true" disabled><img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                        <button @click="showAccDiag()" class="btn btn-primary accActiv" v-if="acc == false">Accéléré <img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                      </div>
                      <p class="heure-brut-warning" v-if="eleve.heureAProgBrut < 0">
                        Vous avez réservé plus d'heures que préconisé, c'est prudent.
                      </p>
                    </div>
                    <div class="prog-hours" v-if="eleve.nbHeureSimu !== 'not' && eleve.nbHeureSimu > 0">
                      <span class="hours-label">H simu à faire:</span>
                      <span class="hours-value">{{ eleve.nbHeureSimu }}h</span>
                    </div>
                    <template v-if="this.eleve.aac === true">
                      <button class="btn btn-danger" v-if="this.niveauEleve >= this.eleve.agence.examProgress" @click="goToExam">EXAMEN</button>
                      <p class="aacTextDate-mobile" v-if="this.eleve.aac === true && this.eleve.aacInfos.aacInfo.status !== 'null' && this.eleve.aacInfos.aacInfo.status !== 'fin'">RDV <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp'">préalable</template> <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp1'">pédagogique 1</template> <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp2'">pédagogique 2</template> <template v-if="this.eleve.aacInfos.aacInfo.dateEstime !== 'null'">date estimée</template> : <template v-if="this.eleve.aacInfos.aacInfo.date === 'null'">à programmer</template><template v-else>{{ this.eleve.aacInfos.aacInfo.date }}</template></p>
                    </template>
                  </div>

                  <div class="bar">
                    <div class="niveau-block">
                      <div class="titlePart">
                        <span>Niveau de formation</span>
                      </div>
                      <div class="progressBar" @click="goToTrame">
                        <p class="lvlEleveBefore">{{ this.niveauEleve }}%</p>
                        <div class="validProgressbar" :style="{ width: niveauEleve + '%', backgroundColor: niveauColor }">
                          <span class="lvlLabel">{{ niveauEleve }}%</span>
                        </div>
                      </div>
                    </div>
                    <div class="heures-block">
                      <div class="titlePart">
                        <span>Nb heures à programmer</span>
                      </div>
                      <div class="heure-equation">
                        <div class="heure-box heure-box-clickable" @click="showTrameDialog = true">
                          <span class="heure-box-value">{{ eleve.heureRestanteTrame }}h</span>
                          <span class="heure-box-label">H pour finir la formation</span>
                        </div>
                        <span class="heure-op">-</span>
                        <div class="heure-box heure-box-clickable" @click="showHeuresProgrammeesDialog = true">
                          <span class="heure-box-value">{{ heureProgrammees }}h</span>
                          <span class="heure-box-label">{{ heureProgrammeesLabel }}</span>
                        </div>
                        <span class="heure-op">=</span>
                        <div class="heure-box heure-box-highlight">
                          <span class="heure-box-value">{{ eleve.heureAProg }}h</span>
                          <span class="heure-box-label">H à programmer</span>
                        </div>
                        <button @click="showAccDiag()" class="btn btn-danger accActiv" v-if="acc == true" disabled><img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                        <button @click="showAccDiag()" class="btn btn-primary accActiv" v-if="acc == false">Accéléré <img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                      </div>
                      <p class="heure-brut-warning" v-if="eleve.heureAProgBrut < 0">
                        Vous avez réservé plus d'heures que préconisé, c'est prudent.
                      </p>
                    </div>
                    <button class="examBtn" v-if="this.niveauEleve >= this.eleve.agence.examProgress" @click="goToExam">EXAMEN</button>
                  </div>
                  <p class="aacTextDate" v-if="this.eleve.aac === true && this.eleve.aacInfos.aacInfo.status !== 'null' && this.eleve.aacInfos.aacInfo.status !== 'fin'">RDV <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp'">préalable</template> <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp1'">pédagogique 1</template> <template v-if="this.eleve.aacInfos.aacInfo.status == 'rdvp2'">pédagogique 2</template> <template v-if="this.eleve.aacInfos.aacInfo.dateEstime !== 'null'">date estimée</template> : <template v-if="this.eleve.aacInfos.aacInfo.date === 'null'">à programmer</template><template v-else>{{ this.eleve.aacInfos.aacInfo.date }}</template></p>

                </div>
              </div>
              
              <div class="midr">
                <div class="fith">
                  <div class="solde-card">
                    <div class="solde-card-txt">
                      <span class="solde-card-label" @click="showSolde">Solde</span>
                      <span class="solde-card-value" @click="showSolde">{{formatSolde(eleve.solde)}} €</span>
                    </div>
                    <button class="solde-card-add" @click="showCred()">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    </button>
                  </div>
                  <div class="formation">
                    <button @click="showAccDiag()" class="btn btn-primary accActiv"  disabled v-if="eleve.nbHeureSimu !== 'not' && eleve.nbHeureSimu > 0">H simu à faire : {{ eleve.nbHeureSimu }}</button>
                  </div>
                </div>
              </div>
              
              <div class="right">
                <div class="pageInfo">
                  <div class="btnLeft">
                    <button class="btn btn-danger boite" disabled v-if="eleve.boite === 2">BM</button>
                    <button class="btn btn-danger boite" disabled v-if="eleve.boite === 1">BA</button>
                    <button class="btn btn-success" disabled v-if="eleve.aac === true"><img src="../../../assets/images/conduite/aac.png" class="logoaac" alt=""></button>
                  </div>
                  <div class="dropdown">
                    <button @click="showAccDiag()" class="btn btn-primary profileBtn" disabled><img @click="goToHome()" class="goProfile" :src="require('../../../assets/images/conduite/profile.png')" /></button>
                    <div class="dropdown-content">
                      <p>{{this.eleve.nom}} {{this.eleve.prenom}}</p>
                      <router-link to="/home"><a href="#">Accueil</a></router-link>
                      <!--
                      <router-link to="/Lycee"><a href="#">Mes Examens</a></router-link>
                      <router-link to="/trame/eleve/"><a href="#">Mon Suivi</a></router-link>
                      -->
                      <a @click="this.$store.commit('setShowMonoElevePage', true);">Paramètrage</a>
                      <a href="#" @click="deconnexion">Déconnexion</a>
                    </div>
                  </div>

                  <div class="dropdownMob" @click="showNavMobilePerso">
                    <button @click="showAccDiag()" class="btn btn-primary profileBtn" disabled><img @click="goToHome()" class="goProfile" :src="require('../../../assets/images/conduite/profile.png')" /></button>
                    <div class="dropdown-contentMob">
                      <p>{{this.eleve.nom}} {{this.eleve.prenom}}</p>
                      <router-link to="/home"><a href="#">Accueil</a></router-link>
                      <a @click="this.$store.commit('setShowMonoElevePage', true);">Paramètrage</a>
                      <a href="#" @click="deconnexion">Déconnexion</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mobile-right">
                <div class="title-mobile">
                  <span>Informations</span>
                </div>
                <div class="content-mobile">
                  <button class="btn btn-primary" @click="showSolde">{{formatSolde(eleve.solde)}} €</button>
                  <button @click="showAccDiag()" class="btn btn-danger accActiv" v-if="acc == true" disabled><img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                  <button @click="showAccDiag()" class="btn btn-primary accActiv" v-if="acc == false">Accéléré <img src="../../../assets/images/conduite/eclair.png" class="logoaac" alt=""></button>
                    <button class="btn btn-danger boite" disabled v-if="eleve.boite === 2">BM</button>
                    <button class="btn btn-danger boite" disabled v-if="eleve.boite === 1">BA</button>
                  <button class="btn btn-success" disabled v-if="eleve.aac === true"><img src="../../../assets/images/conduite/aac.png" class="logoaac" alt=""></button>
                  <button class="btn btn-primary params" @click="goToParams"><img src="../../../assets/images/params.png" alt=""></button>
                </div>
              </div>

            </div>
          </div>

          <div class="form-resa">
            <div v-if="this.showBtnResa == true" class="resaSelect">

              <select name="monoSelect" id="" @change="setupMoniteurChoice" v-model="monoResa">
                <option value="null">Choisir un moniteur</option>
                <template v-for="m in listMonoResa" :key="m.id">
                  <option :value="m.idMono" :title="m.fullname">{{ m.surnom }}</option>
                </template>
              </select>
              <button v-if="monoResa === 'null'" class="btn btn-primary paramsweb" @click="goToParams">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
                Ajouter / modifier mes moniteurs
              </button>
              <div v-if="monoResa !== 'null'" class="lieuAgence" style="display:inline-flex;flex-direction:row;flex-wrap:nowrap;align-items:stretch;border:1.5px solid #e2e8f0;border-radius:10px;overflow:hidden;background:#f4f6f9;">
                <div class="lieuDeb">
                  <span class="titleLieu">DEPART</span>
                  <span class="lieuNom">{{ this.agenceLieu.nom }}</span>
                </div>
                <div class="lieuDeb">
                  <span class="titleLieu">ARRIVEE</span>
                  <span class="lieuNom">{{ this.agenceLieu.nom }}</span>
                </div>
              </div>
              <button v-if="monoResa !== 'null'" class="btn btn-primary paramsweb" @click="goToParams">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
                Ajouter / modifier mes moniteurs
              </button>

              <!--<p>Pas encore disponible</p>-->
            </div>
            <div v-else class="dispoSelec">
              <select name="dispoSelec" id="" v-model="lieuSelec" @change="changeLieuDispo">
                <option value="">Lieu Dispo</option>
                <template v-for="l in lieuxDispo" :key="l.id">
                  <option :value="l.id" :title="l.fulladresse">{{ l.nom }}</option>
                </template>
              </select>
              <button class="btn btn-primary paramsweb" @click="goToParams">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
                Ajouter / modifier mes lieux
              </button>
              <button class="btn btn-primary" @click="sendMailUpdateDispo">MAJ</button>
            </div>
          </div>

        </template>


        <Dialog v-model:visible="showAcc" modal header="Permis Accéléré" :style="{ width: '400px', maxWidth: '95vw' }" :breakpoints="{ '575px': '95vw' }">
          <div class="acc-dialog">
            <div class="acc-icon-wrap">
              <img src="../../../assets/images/conduite/eclair.png" class="acc-dialog-icon" alt="">
            </div>
            <div class="acc-price-badge">{{ permisAcc ? permisAcc.montant : '...' }} €</div>
            <p class="acc-desc">Réservez vos heures de conduite de manière illimitée pendant toute votre formation.</p>
            <div class="acc-warning">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <span>Cette action est <strong>irréversible</strong>. Une fois validé, vous ne pourrez pas revenir en arrière ni obtenir un remboursement.</span>
            </div>
            <div class="acc-actions">
              <button class="credit-btn credit-btn--ghost" @click="cancelAcc">Retour</button>
              <button class="credit-btn credit-btn--primary" @click="setAcc">Valider</button>
            </div>
          </div>
        </Dialog>

        <Dialog v-model:visible="showCredit" modal header="Créditer votre solde" :style="{ width: '420px', maxWidth: '95vw' }" :breakpoints="{ '575px': '95vw' }">
          <div class="credit-dialog">
            <p class="credit-desc">Saisissez le montant à créditer sur le solde de l'élève.</p>
            <div class="credit-field">
              <label class="credit-label" for="montant">Montant</label>
              <div class="credit-input-wrap">
                <input type="number" id="montant" name="montant" v-model="credit" class="credit-input" placeholder="0" min="0" />
                <span class="credit-suffix">€</span>
              </div>
            </div>
            <div class="credit-actions">
              <button class="credit-btn credit-btn--ghost" @click="cancelCred">Annuler</button>
              <button class="credit-btn credit-btn--primary" @click="setCredit()" :disabled="credit === ''">Valider</button>
            </div>
          </div>
        </Dialog>


        <Dialog v-model:visible="soldeBtn" modal :header="headerSolde" :style="{ width: '70%' }">

          <template #header>
            <div class="headSolde">
              <h3>{{ this.eleve.fullname }}</h3>
              <button @click="showCred()" class="btn btn-primary">CREDITER</button>
              <button class="btn btn-primary btnSwitchSolde" @click="changeSoldBtn" v-if="soldeSoldebtn">Heures ></button>
              <button class="btn btn-primary btnSwitchSolde" @click="changeSoldBtn" v-if="soldeRdvBtn">&lt; Solde</button>
              
            </div>
          </template>

          <div class="soldePage" v-if="soldeSoldebtn">
            <paiement :data="eleve" :modal="false" />
            
          </div>
          <div class="rdvPage" v-if="soldeRdvBtn">
            <div class="table-wrap table-wrap--modal">
            <DataTable :value="eleve.rdvs" tableStyle="min-width: 50rem" responsiveLayout="scroll">
              <Column field="type" header="Type"></Column>
              <Column field="ladate" header="Date"></Column>
              <Column field="heure" header="Heure"></Column>
              <Column field="moniteur.fullname" header="Mono"></Column>
              <Column field="lieuDeb.nom" header="Début"></Column>
              <Column field="lieuFin.nom" header="Fin"></Column>
              <Column field="commentaire" header="Commentaire"></Column>
            </DataTable>
            </div>
          </div>
        </Dialog>
        <div class="nav-mobile">
          <div class="nav-content">
            <div class="home-mobile" @click="showMobileVue('home')">
              <img src="../../../assets/images/home.png" alt="">
              <span id="nav-title-home">Accueil</span>
            </div>
            <div class="resa-mobile" @click="showMobileVue('resa')">
              <img src="../../../assets/images/resa.png" alt="">
              <span id="nav-title-resa" class="active">Réservation</span>
            </div>
            <div class="prog-mobile" @click="showMobileVue('prog')">
              <img src="../../../assets/images/progress.png" alt="">
              <span id="nav-title-prog">Progression</span>
            </div>
            <div class="info-mobile" @click="showMobileVue('perso')">
              <img src="../../../assets/images/information.png" alt="">
              <span id="nav-title-info">Information</span>
            </div>
            <div class="lougout-mobile" @click="showMobileVue('logout')">
              <img src="../../../assets/images/logout.png" alt="">
              <span id="nav-title-logout">Déconnexion</span>
            </div>
          </div>
        </div>

        <Dialog v-model:visible="showSimuInfoModal" modal header="Simulateur" :style="{ width: '420px', maxWidth: '95vw' }" :breakpoints="{ '575px': '95vw' }">
          <div class="simu-warn-dialog">
            <div class="simu-info-icon">🖥️</div>
            <p class="simu-warn-text">
              Après avoir réservé vos <strong>{{ eleve.nbHeureSimu }}h</strong> sur simulateur, vous aurez accès à :
            </p>
            <ul class="simu-warn-list">
              <li>la conduite en véhicule</li>
              <li>l'ajout de moniteurs</li>
              <li>l'ajout de lieux de RDV autres que l'agence</li>
            </ul>
            <div class="simu-warn-actions">
              <button class="credit-btn credit-btn--primary" @click="showSimuInfoModal = false">J'ai compris</button>
            </div>
          </div>
        </Dialog>

        <Dialog v-model:visible="showSimuWarning" modal header="Simulateur obligatoire" :style="{ width: '420px', maxWidth: '95vw' }" :breakpoints="{ '575px': '95vw' }">
          <div class="simu-warn-dialog">
            <p class="simu-warn-text">
              Vous avez <strong>{{ eleve.nbHeureSimu }}h</strong> à faire sur le simulateur situé à l'agence.<br>
              Réservez ces {{ eleve.nbHeureSimu }}h sur <strong>SIMU</strong>, puis vous pourrez ajouter des lieux de conduite en véhicule autres que l'agence.
            </p>
            <div class="simu-warn-actions">
              <button class="credit-btn credit-btn--primary" @click="showSimuWarning = false">J'ai compris</button>
            </div>
          </div>
        </Dialog>

        <Dialog v-model:visible="infoResaModal" modal :header="headerInfoResaModal" :style="{ width: '480px', maxWidth: '95vw' }">

          <!-- MODE : Je définis mes dispos -->
          <div v-if="dispoOrResa === 'false'" class="info-modal-content">
            <ol class="info-modal-steps">
              <li>
                <span class="step-num">1</span>
                <div class="step-body">
                  <strong>Choisissez un lieu de RDV</strong> qui vous arrange
                </div>
              </li>
              <li>
                <span class="step-num">2</span>
                <div class="step-body">
                  Posez un <strong>maximum de dispos</strong> sur le lieu choisi
                </div>
              </li>
              <li>
                <span class="step-num">3</span>
                <div class="step-body">
                  Pour des raisons d'organisation les cours sur <strong>lieux autres que l'agence</strong> vous seront proposés par l'agence
                </div>
              </li>
              <li>
                <span class="step-num">4</span>
                <div class="step-body">
                  Vous pourrez par contre <strong>réserver vous-même</strong> les cours qui auront pour lieu de RDV <strong>l'agence</strong>
                </div>
              </li>
            </ol>
          </div>

          <!-- MODE : Je réserve mes heures -->
          <div v-else class="info-modal-content">
            <ol class="info-modal-steps">
              <li>
                <span class="step-num">1</span>
                <div class="step-body">
                  <strong>Choisissez un moniteur</strong>
                </div>
              </li>
              <li>
                <span class="step-num">2</span>
                <div class="step-body">
                  Réservez un cours en cliquant sur un
                  <span class="info-modal-tag info-modal-tag--green">CRÉNEAU DISPO</span>
                </div>
              </li>
              <li>
                <span class="step-num">3</span>
                <div class="step-body">
                  Pour rappel, les cours sur <strong>les lieux autres que l'agence</strong> vous seront proposés par l'agence
                </div>
              </li>
              <li>
                <span class="step-num">4</span>
                <div class="step-body">
                  <template v-if="acc == true">
                    Vous êtes en <strong>permis accéléré</strong> ⚡, vous pouvez réserver en <strong>illimité</strong>
                  </template>
                  <template v-else>
                    Vous aurez droit à <strong>{{eleve.agenceDroit}}h / semaine</strong>. Passez en
                    <a class="info-modal-link" @click="showAccDiag()">accéléré</a>
                    pour réserver en illimité
                  </template>
                </div>
              </li>
              <li>
                <span class="step-num">5</span>
                <div class="step-body">
                  Pensez à <strong>créditer</strong> votre solde s'il est insuffisant
                </div>
              </li>
            </ol>
          </div>

        </Dialog>

        <Dialog
          v-model:visible="showTrameDialog"
          modal
          header="Ma progression"
          :style="{ width: '90vw', maxWidth: '1400px' }"
        >
          <TrameEleve v-if="showTrameDialog" :eleveId="eleve.id" :embedded="true" />
        </Dialog>

        <Dialog
          v-model:visible="showHeuresProgrammeesDialog"
          modal
          :header="heuresProgrammeesDialogTitle"
          :style="{ width: '70vw', maxWidth: '1000px' }"
        >
          <DataTable :value="heuresProgrammeesList" tableStyle="width: 100%" :rows="10" class="heures-prog-table" :paginator="heuresProgrammeesList.length > 10">
            <template #empty>
              <div class="heures-prog-empty">Aucune heure programmée à venir</div>
            </template>
            <Column field="type" header="Type">
              <template #body="slotProps">
                <span class="type-badge">{{ slotProps.data.type }}</span>
              </template>
            </Column>
            <Column field="ladate" header="Date"></Column>
            <Column field="heure" header="Heure"></Column>
            <Column header="Lieu début">
              <template #body="slotProps">{{ slotProps.data.lieuDeb.nom }}</template>
            </Column>
            <Column header="Lieu fin">
              <template #body="slotProps">{{ slotProps.data.lieuFin.nom }}</template>
            </Column>
            <Column header="Moniteur">
              <template #body="slotProps"><span class="mono-name">{{ slotProps.data.moniteur.fullname }}</span></template>
            </Column>
          </DataTable>
        </Dialog>

    </div>
  </template>
  
  <script>

  import moment from "moment";
  import { useToast } from "primevue/usetoast";
  import paiement from "@/components/eleve/Paiement.vue";
  import TrameEleve from "@/views/eleve/Conduite/TrameEleve.vue";

  export default {

      props: [
        "acc",
        "eleve",
        "setDisplayResaDispo",
        "setupLieuDispo",
        "setupMonoChoice",
        "setResa",
        "setDispoMobile"
      ],

    components: {
      paiement,
      TrameEleve
    },
  
    computed: {
      isMobile() {
        return window.innerWidth <= 768;
      },
      heureProgrammees() {
        return this.eleve.heuresDejaProg;
      },
      heuresProgrammeesList() {
        return (this.eleve.apointments || [])
          .filter((a) =>
            a.done === false &&
            a.cancelRdv === "null" &&
            a.moniteur.fullname !== "Le Simulateur" &&
            a.statAac !== "rdvp" && a.statAac !== "rdvp1" && a.statAac !== "rdvp2" &&
            new Date(a.start.date) > new Date()
          )
          .sort((a, b) => new Date(a.start.date) - new Date(b.start.date));
      },
      heureProgrammeesLabel() {
        if (!this.eleve.aac || this.eleve.rdvpFait) {
          return "H programmées";
        }
        return "H programmées avant RDV préalable";
      },
      heuresProgrammeesDialogTitle() {
        if (!this.eleve.aac || this.eleve.rdvpFait) {
          return "Heures programmées à venir";
        }
        let title = "Heures programmées à venir avant le RDV préalable";
        if (this.eleve.dateRdvp && this.eleve.dateRdvp !== "RDVP NON PROG") {
          title += " du " + this.eleve.dateRdvp;
        }
        return title;
      },
      niveauColor() {
        if (this.niveauEleve < 30) return "#dd3737";
        if (this.niveauEleve < 60) return "#DD9037FF";
        if (this.niveauEleve < 90) return "#3792DDFF";
        return "#37DD69FF";
      },
    },

    watch: {
      dateResa: function () {
          this.getHeuresResa();
          this.setupDateResaEleve(this.dateResa);
      },
      'eleve.nbHeureSimu': function (newVal) {
        if (newVal !== 'not' && newVal > 0) {
          this.listMonoResa = this.eleve.monoChoix.filter((e) => e.surnom == 'Simu');
        } else {
          this.listMonoResa = this.eleve.monoChoix.filter((e) => e.surnom != 'Simu');
        }
      },
    },
  
    data() {
      return {
        toast: useToast(),
        typeSelectChoice : false,
        showAcc : false,
        showCredit : false,
        credit : "",
        soldeRdvBtn : false,
        soldeSoldebtn : true,
        soldeBtn: false,
        permisAcc : null,
        showBtnResa : "null",
        niveauEleve : 0,
        heurePreco : 10,
        lieuxDispo: [],
        monoResa : 'null',
        lieuDebResa : 'null',
        lieuFinResa : 'null',
        creneau : 'null',
        dateResa : 'null',
        heureResa : 'null',
        heuresResa : [],
        today: this.getTodayDate(),
        showDropDownInfo : false,
        loadBtn : false,
        dateDispo : '',
        heureDebDispo : '',
        heureFinDispo : '',
        lieuSelec : '',
        dispoOrResa: "true",
        agenceLieu : [],
        listMonoResa: [],
        infoResaModal: false,
        headerInfoResaModal : "",
        showSimuWarning: false,
        showSimuInfoModal: false,
        showTrameDialog: false,
        showHeuresProgrammeesDialog: false,

      };
    },
  
    mounted() {
      this.getFonctionnalite();
      this.getLieuxEleve();
      this.setDispoOrResa(true);
      this.getLieuAgence();
      this.niveauEleve = this.eleve.tramePourcent;

      if(this.eleve.lieuRdv.length == 1){
        this.$store.commit("setLieuDebResaEleve", this.eleve.lieuRdv[0]["id"]);
        this.$store.commit("setLieuFinResaEleve", this.eleve.lieuRdv[0]["id"]);
      }

      if(this.eleve.nbHeureSimu > 0){
        this.listMonoResa = this.eleve.monoChoix.filter((e) => e.surnom == 'Simu');
        //this.monoResa = this.listMonoResa[0].idMono;
      }else{
        this.listMonoResa = this.eleve.monoChoix.filter((e) => e.surnom != 'Simu');
        //this.monoResa = this.listMonoResa[0].idMono;
      }

    },
  
    methods: {

      openInfoResaModal(){
        this.infoResaModal = true;
        if(this.dispoOrResa === "false"){
          this.headerInfoResaModal = "Je définis mes dispos";
        }else{
          this.headerInfoResaModal = "Je réserve mes heures";
        }
      },

      getLieuAgence(){
        window.api
          .get(
            "/agence/lieu/"+this.$store.state.user.agence.id,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.$store.commit("setLieuDebResaEleve", response.data.id);
            this.$store.commit("setLieuFinResaEleve", response.data.id);
            this.agenceLieu = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },

      setupDispo(){
        if(this.lieuSelec === "" || this.lieuSelec === "null" || this.dateDispo === "" || this.heureDebDispo === "" || this.heureFinDispo === ""){
          alert("Veuillez remplir tous les champs");
        }else{
          this.$emit("setDispoMobile", this.dateDispo, this.heureDebDispo, this.heureFinDispo, this.lieuSelec);
        }
      },

      formatSolde(v){
        return Number(v).toLocaleString('fr-FR');
      },

      sendMailUpdateDispo(){
        window.api
          .get(
            "/update/dispo/eleve/"+this.$store.state.user.id,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then(() => {
                this.toast.add({
                  severity: "success",
                  summary: "Disponibilité",
                  detail: "Votre agence a bien été informée de vos disponibilités",
                  life: 3000,
                });
          })
          .catch((error) => {
            console.log(error);
          });
      },

      goToExam(){
        this.$router.push({ name: "EleveExam", params: { id: this.eleve.id}});
      },

      goToTrame(){
        this.$router.push({ name: "trame_eleve", params: { id: this.eleve.id, "return": "eleve" }});
      },

      getTodayDate() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Mois 0-based
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      },


      clearValuesResa(){
        this.heureResa = 'null';
        this.heuresResa = [];
        this.$store.commit("setCreneauResa", null);
        this.dateResa = 'null';
        this.$store.commit("setdateResa", null);
        this.$store.commit("setloadResaEleveBtn", false);
      },

      resetMono(){
        this.monoResa = 'null';
      },

      resaEleve(){
        this.$store.commit("setloadResaEleveBtn", true);
        this.$emit("setResa");
      },

      getHeuresResa(){
        let nowDate = new Date();
        window.api
          .post(
            "/horaire/planning/eleve",
            {
              date: this.dateResa,
              monoId : this.monoResa,
              eleveId : this.eleve.id,
              now: moment(nowDate.date).format(
                        "YYYY-MM-DDTHH:mm:ss"
                      ),
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.heuresResa = response.data.heures;
          })
          .catch((error) => {
            console.log(error);
          });

      },

      setupLieuDebResaEleve(){
        this.$store.commit("setLieuDebResaEleve", this.lieuDebResa.id);
      },

      setupLieuFinResaEleve(){
        this.$store.commit("setLieuFinResaEleve", this.lieuFinResa.id);
      },

      setupDateResaEleve(l){
        this.$store.commit("setdateResa", l);
      },

      setupCreneauResaEleve(){
        this.$store.commit("setCreneauResa", this.heureResa);
      },

      setupMoniteurChoice(){
        let moniteur = "null";
        if(this.monoResa !== "null"){
          moniteur = this.listMonoResa.find(m => m.idMono === this.monoResa);
        }

        if (moniteur !== "null" && moniteur && moniteur.surnom === "Simu") {
          this.showSimuInfoModal = true;
        }

        if(this.$store.state.elevePlanningInfo != null){
          if(moniteur !== "null"){
            let findMono = null;
            findMono = this.$store.state.elevePlanningInfo.monoChoix.find((ed) => ed.idMono == moniteur.idMono);
            if(findMono != undefined){
              this.$emit("setupMonoChoice", findMono);
            }
          }else{
            this.$emit("setupMonoChoice", moniteur);
          }
        }else{
          this.$emit("setupMonoChoice", moniteur);
        }

      },

      changeLieuDispo(e){
        const lieu = this.lieuxDispo.find(m => m.id == e.target.value);
        if(e.target.vlaue !== "null"){
          if(lieu.groupe === 2){
            alert("Pour des raisons d'organisation, seule l'agence pourra vous proposer des cours sur ce lieu de rendez-vous. Le temps de trajet entre l'agence et ce lieu de rdv (environ 10/15 min) sera décompté de votre cours");
          }else if(lieu.groupe === 3){
            alert("Pour des raisons d'organisation, seule l'agence pourra vous proposer des cours sur ce lieu de rendez-vous.");
          }
          this.setLieuDispo(e.target.value);
        }
      },

      setLieuDispo(l){
        this.$emit("setupLieuDispo", l);
      },

      getLieuxEleve() {
        window.api
          .get("/eleve/lieux/" + this.$store.state.user.id, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            response.data.lieux.forEach(l => {
                let findL = null;
                findL = this.lieuxDispo.find(e => e.id == l.id)
                if(findL == undefined){
                  this.lieuxDispo.push(l);
                }
              })
          })
          .catch((error) => {
            console.log(error);
          });
      },

      deconnexion() {
        this.$store.commit("setUser", null);
        this.$store.commit("setToken", null);
        localStorage.removeItem("user_info");
        localStorage.removeItem("user_access");
        this.$router.push({name: 'index'});
      },

      getFonctionnalite() {
      window.api
        .get("/fonctionnalites", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.permisAcc = response.data["hydra:member"].find((e) => e.label == "permis accéléré");
        })
        .catch((error) => {
          console.log(error);
        });
    },

      showSolde(){
        if(this.soldeBtn){
          this.soldeBtn = false;
        }else{
          this.soldeBtn = true;
        }
      },

      changeSoldBtn(){
        if(this.soldeRdvBtn){
          this.soldeSoldebtn = true;
          this.soldeRdvBtn = false;
        }else{
          this.soldeSoldebtn = false;
          this.soldeRdvBtn = true;
        }
      },


      changeDispoOrResa(e){
        
        if(e.target.value === "null"){
          this.setDispoOrResa('null');
          this.lieuDebResa = "null";
          this.lieuFinResa= "null";
          this.dateResa = "null";
          this.heureResa = "null";
          this.lieuSelec = "";
        }else if(e.target.value === "false"){
          this.setDispoOrResa(false);
          this.lieuDebResa = "null";
          this.lieuFinResa= "null";
          this.dateResa = "null";
          this.heureResa = "null";
          this.lieuSelec = "";
        }else if(e.target.value === "true"){
          this.setDispoOrResa(true);
          this.lieuDebResa = "null";
          this.lieuFinResa= "null";
          this.dateResa = "null";
          this.heureResa = "null";
          this.lieuSelec = "";
          // setTimeout(() => {
          //   this.setupMoniteurChoice();
          // }, "200");
          
        }
      },

      setDispoOrResa(event){
        if(event == true){
          window.api
            .get("/agences/" + this.$store.state.user.agence.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              document.querySelector(".form-resa").style.display = "block";
              if(response.data.autoPlanning == false){
                //alert("Vous ne pouvez actuellement pas réserver de cours, la fonctionnalité arrivera prochainement, veuillez contacter votre agence pour réserver un cours");
                this.$store.commit("setDispoOrResa", true);
                this.$emit("setDisplayResaDispo", true);
                this.showBtnResa = true;
                this.dispoOrResa = "true";
              }else{
                this.$store.commit("setDispoOrResa", true);
                this.$emit("setDisplayResaDispo", true);
                this.showBtnResa = true;
                this.dispoOrResa = "true";
              }

              if(this.monoResa !== "null"){
                this.setupMoniteurChoice();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }else if(event == false){
          this.$store.commit("setDispoOrResa", false);
          this.$emit("setDisplayResaDispo", false);
          document.querySelector(".form-resa").style.display = "block";
          this.showBtnResa = false;
        }else{
          this.showBtnResa = "null";
          document.querySelector(".form-resa").style.display = "none";
          this.$store.commit("setDispoOrResa", false);
          this.$emit("setDisplayResaDispo", true);
        }
      },

      setCredit(){
        let mode = "cb";
        this.$store.dispatch("startSaveBouton", mode);
        let fonctionnalite = "solde";
        let router = this.$router;
        let montantParam = this.credit;
        this.$store.dispatch("endSaveBouton", { mode, fonctionnalite, router, montantParam });
      },

      showCred(){
        this.showCredit = true;
      },

      cancelCred(){
        this.showCredit = false;
      },

      cancelAcc(){
        this.showAcc = false;
      },

      setAcc(){
        window.api
          .post(
            "/permis/aac",
            {
              eleve: this.eleve.id,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            if(response.data.message != "Solde insufisant"){
              this.showAcc = false;
              this.$emit("getEleveInfo");
              window.location.reload();
            }else{
              alert("Solde de l'élève insufisant");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },

      showAccDiag(){
        this.showAcc = true;
      },

      showMono(e){
        if(e){
          this.$store.commit("setShowMonoElevePage", true);
        }else{
          this.$store.commit("setShowMonoElevePage", false);
          window.location.reload();
        }
      },

      goToParams(){
        if (this.eleve.nbHeureSimu !== 'not' && this.eleve.nbHeureSimu > 0) {
          this.showSimuWarning = true;
          return;
        }
        document.querySelector("div.nav-mobile").style.display = "none";
        this.$store.commit('setShowMonoElevePage', true);
      },

      showMobileVue(vue){
        if(vue == 'resa'){
          document.querySelector("div.left").style.display = "block";
          document.querySelector("div.center").style.display = "none";
          document.querySelector("div.mobileProg").style.display = "none";
          document.querySelector("div.mobile-right").style.display = "none";
          document.querySelector("#nav-title-resa").classList.add("active")
          document.querySelector("#nav-title-prog").classList.remove("active")
          document.querySelector("#nav-title-info").classList.remove("active")
        }else if(vue == 'prog'){
          document.querySelector("div.center").style.display = "block";
          document.querySelector("div.mobileProg").style.display = "block";
          document.querySelector("div.mobile-right").style.display = "none";
          document.querySelector("div.left").style.display = "none";
          document.querySelector("#nav-title-resa").classList.remove("active")
          document.querySelector("#nav-title-prog").classList.add("active")
          document.querySelector("#nav-title-info").classList.remove("active")
        }else if(vue == 'home'){
          this.$router.push({ name: "Home" });
        }else if(vue == 'logout'){
          this.$store.commit("setUser", null);
          this.$store.commit("setToken", null);
          localStorage.removeItem("user_info");
          localStorage.removeItem("user_access");
          this.$router.push({name: 'index'});
        }else{
          document.querySelector("div.mobile-right").style.display = "block";
          document.querySelector("div.left").style.display = "none";
          document.querySelector("div.center").style.display = "none";
          document.querySelector("div.mobileProg").style.display = "none";
          document.querySelector("#nav-title-resa").classList.remove("active")
          document.querySelector("#nav-title-prog").classList.remove("active")
          document.querySelector("#nav-title-info").classList.add("active")
        }
      },

      goBackAction(){
        document.querySelector("div.goBackCallAction").style.display = "none";
        document.querySelector("div.mobileCallAction").style.display = "flex";
        document.querySelector("div.left").style.display = "none";
        document.querySelector("div.center").style.display = "none";
        document.querySelector("div.mobileProg").style.display = "none";
        document.querySelector("div.midr").style.display = "none";
        document.querySelector("div.right").style.display = "none";
      },

      showNavMobilePerso(){
        if(this.showDropDownInfo == true){
          this.showDropDownInfo = false;
          document.querySelector("div.dropdown-contentMob").style.display = "none";
        }else{
          this.showDropDownInfo = true;
          document.querySelector("div.dropdown-contentMob").style.display = "block";
        }
        
      }



    }
  };
  </script>


<style scoped>

/* ===== Info Resa Modal ===== */
.info-modal-content {
  padding: 4px 0 8px;
}

.info-modal-steps {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.info-modal-steps li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.step-num {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.step-body {
  font-size: 14px;
  color: #1a1f2e;
  line-height: 1.5;
}

.info-modal-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: #fef3c7;
  color: #b45309;
  margin-left: 4px;
}

.info-modal-tag--green {
  background: #bf616a;
  color: #ffffff;
}

.info-modal-link {
  color: #3b82f6;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px solid #bfdbfe;
  padding-bottom: 1px;
  transition: color 0.15s;
}
.info-modal-link:hover {
  color: #1d4ed8;
}

  button.paramsweb img {
    width: 20px;
    height: 20px;
  }

div.lieuAgence {
  display: inline-flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #f4f6f9;
  width: fit-content !important;
}

div.lieuAgence div.lieuDeb {
  display: flex !important;
  flex-direction: column !important;
  padding: 6px 12px;
  white-space: nowrap;
  flex-shrink: 0;
  width: auto !important;
}

.lieuDeb:first-child {
  border-right: 1px solid #e2e8f0;
}

.titleLieu {
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
  display: block;
  text-align: left;
}

.lieuNom {
  font-size: 10px;
  font-weight: 600;
  color: #1a1f2e;
  display: block;
}

.lieuArrow {
  color: #94a3b8;
  font-size: 10px;
  padding: 0 8px;
  align-self: center;
  flex-shrink: 0;
  display: flex !important;
}

p.info-resa{
  font-size: 12px;
  margin-top: 1rem;
  color: #6182f7;
  font-weight: bold;
}

/* ===================== CONTENEUR PRINCIPAL ===================== */
div.headerPlanning {
  width: 100%;
  margin-bottom: 8px;
}

div.header-container{
  display: flex;
  width: 95%;
  margin: 12px auto 0;
  gap: 20px;
}

div.choix-header{
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 5px 20px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
  margin: 0 auto;
  position: relative;


}

div.form-resa{
    position: relative;
    width: 95%;
    margin: 2px auto 0;

    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    box-shadow: 4px 8px 32px rgba(0,0,0,.07);
    padding: 4px 10px;
    display: block;
    z-index: 400;
    transform-origin: top left;
    animation: panelIn .2s ease;
    box-sizing: border-box;
}

@keyframes panelIn {
  from { opacity: 0; transform: translateX(-12px); }
  to   { opacity: 1; transform: translateX(0); }
}

div.choix-header select{
  padding: 9px 32px 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
  margin-right: 6px;
  margin-bottom: 6px;
}

/* ===================== TOOLBAR PRINCIPALE ===================== */
div.headerContent {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 5px 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
  width: 100%;
  margin: 0 auto;

}

/* ===================== LABELS DE SECTION ===================== */
div.titlePart {
  margin-bottom: 6px;
  cursor: pointer;
}

div.titlePart span {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
}

/* ===================== COLONNE GAUCHE ===================== */
div.headerContent div.left {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-shrink: 0;
}

div.headerContent div.left div.first,
div.headerContent div.left div.second {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0;
  display: none;
}

/* ===================== SELECTS ===================== */
div.headerContent div.left select,
div.resaSelect select,
div.dispoSelec select {
  padding: 9px 32px 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
  margin-right: 6px;
  margin-bottom: 6px;
}

div.headerContent div.left select:focus,
div.resaSelect select:focus,
div.dispoSelec select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

/* ===================== ZONE RESA / DISPO ===================== */
div.dispoResa {
  margin-top: 4px;
}

div.resaSelect {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

div.horairePlanning {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

div.horairePlanning input {
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1a1f2e;
  outline: none;
  transition: border-color .15s;
}

div.horairePlanning input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

div.horairePlanning select {
  margin-left: 0;
  margin-right: 0;
}

div.dispoSelec {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

div.dispoMobile label {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-right: 6px;
}

div.dispoMobile input {
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1a1f2e;
  outline: none;
  margin-right: 6px;
  margin-bottom: 6px;
  transition: border-color .15s;
}

div.dispoMobile input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

/* ===================== COLONNE CENTRE (progression) ===================== */
div.headerContent div.center {
  min-width: 220px;
  margin-right: 3rem;
  align-self: stretch;
  display: flex;
}

div.headerContent div.center div.third {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0;
}

div.headerContent div.center div.third div.bar {
  display: flex;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  margin-top: 4px;
  flex: 1;
}

div.headerContent div.center div.third div.niveau-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 16px;
  border-right: 1px solid #e2e8f0;
}

div.headerContent div.center div.third div.niveau-block div.progressBar {
  margin-top: 26px;
}

div.headerContent div.center div.third div.heures-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

div.headerContent div.center div.third div.progressBar {
  height: 8px;
  width: 180px;
  background: #e2e8f0;
  border: none;
  border-radius: 4px;
  position: relative;
  overflow: visible; /* ← fix : "hidden" coupait le label positionné à top:-22px */
  cursor: pointer;
}

div.headerContent div.center div.third div.progressBar p.lvlEleveBefore {
  display: none;
}

div.headerContent div.center div.third div.validProgressbar {
  height: 100%;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  transition: width .4s ease;
  overflow: visible; /* important pour que le label dépasse */
}

div.headerContent div.center div.third div.validProgressbar .lvlLabel {
  position: absolute;
  right: 0;
  top: -22px;
  transform: translateX(50%);
  font-size: 11px;
  font-weight: 700;
  color: #1a1f2e;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 1px 6px;
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(0,0,0,.08);
  pointer-events: none;
  transition: right .4s ease;
}

div.headerContent div.center div.third div.bar span.heure-a-prog {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
  cursor: default;
  position: relative;
}

div.headerContent div.center div.third div.bar span.heure-a-prog:hover::after {
  content: attr(title);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1a1f2e;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 8px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 99;
}

div.headerContent div.center div.third div.heure-equation {
  display: flex;
  align-items: center;
  gap: 8px;
}

div.headerContent div.center div.third div.heure-equation div.heure-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 10px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

div.headerContent div.center div.third div.heure-equation div.heure-box-clickable {
  cursor: pointer;
  transition: background .15s, border-color .15s;
}

div.headerContent div.center div.third div.heure-equation div.heure-box-clickable:hover {
  background: #e8f0fe;
  border-color: #93c5fd;
}

div.headerContent div.center div.third div.heure-equation span.heure-box-value {
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
}

div.headerContent div.center div.third div.heure-equation span.heure-box-label {
  font-size: 9px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

div.headerContent div.center div.third div.heure-equation span.heure-op {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
}

div.headerContent div.center div.third div.heure-equation div.heure-box-highlight {
  background: #e8f7ee;
  border-color: #37DD69FF;
  animation: heureBoxPulse 1.6s ease-in-out infinite;
}

div.headerContent div.center div.third div.heure-equation div.heure-box-highlight span.heure-box-value {
  color: #15803d;
}

div.headerContent div.center div.third div.heure-equation div.heure-box-highlight span.heure-box-label {
  color: #16a34a;
}

div.headerContent div.center div.third div.heure-equation button.accActiv {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  gap: 5px;
  min-width: 44px;
  padding: 4px 10px;
  height: auto;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #1a1f2e;
}

div.headerContent div.center div.third div.heure-equation button.accActiv:hover:not(:disabled) {
  background: #e8f0fe;
  border-color: #93c5fd;
  transform: none;
  box-shadow: none;
}

div.headerContent div.center div.third div.heure-equation button.accActiv:disabled {
  opacity: 1;
}

p.heure-brut-warning {
  margin: 8px 0 0;
  font-size: 11px;
  font-weight: 600;
  color: #1d4ed8;
}

@keyframes heureBoxPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(55, 221, 105, .55);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(55, 221, 105, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(55, 221, 105, 0);
  }
}

div.headerContent div.center div.third div.bar button.examBtn {
  display: inline-flex;
  align-items: center;
  align-self: center;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  background: #3b82f6;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: all .15s;
  letter-spacing: .01em;
}

div.headerContent div.center div.third div.bar button.examBtn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

div.headerContent div.center div.third div.bar button.heurePrev {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  background: #eff6ff;
  color: #3b82f6;
  border: 1px solid #bfdbfe;
  cursor: default;
  margin-left: 6px;
}

p.aacTextDate {
  font-size: 11px;
  color: #64748b;
  margin-top: 6px;
}

p.aacTextDate-mobile {
  font-size: 11px;
  color: #64748b;
  margin-top: 4px;
}

/* Survol heures */
div.survolHeure {
  position: relative;
  display: inline-block;
}

div.survolContent {
  display: none;
  position: absolute;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  min-width: 480px;
  right: -240px;
  box-shadow: 0 10px 40px rgba(0,0,0,.1), 0 4px 12px rgba(0,0,0,.05);
  z-index: 100;
  padding: 16px;
}

div.survolHeure:hover div.survolContent {
  display: block;
}

div.survolContent h4 {
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 10px;
}

div.survolContent div.survolInside div.top p {
  text-align: left;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 10px;
}

div.survolContent div.survolInside div.calcul {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

div.survolContent div.survolInside div.calcul p.operateur {
  font-size: 28px;
  color: #94a3b8;
  font-weight: 300;
}

div.survolContent div.survolInside div.calcul div.case {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  width: 40%;
  overflow: hidden;
}

div.survolContent div.survolInside div.calcul div.header {
  background: #f4f6f9;
  border-bottom: 1px solid #e2e8f0;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: .04em;
}

div.survolContent div.survolInside div.calcul div.number {
  font-size: 22px;
  font-weight: 700;
  color: #1a1f2e;
  padding: 10px;
  text-align: center;
}

div.survolContent div.survolInside div.calcul div.footer {
  border-top: 1px solid #e2e8f0;
  padding: 5px 10px;
  font-size: 11px;
  color: #94a3b8;
  text-align: center;
}

div.survolContent div.survolInside div.calcul div.tot {
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  width: 40%;
  overflow: hidden;
}

div.survolContent div.survolInside div.calcul div.tot div.number {
  color: #3b82f6;
}

div.survolContent div.rdvpInfo li {
  text-align: left;
  font-size: 13px;
  color: #64748b;
  margin: 8px 12px;
  line-height: 1.5;
}

div.infoPedag p {
  font-size: 12px;
  color: #64748b;
  margin-left: 10px;
}

/* ===================== COLONNE MIDR (solde + MAJ) — CORRIGÉ ===================== */
div.headerContent div.midr {
  display: flex;
  flex: 1;
  gap: 8px;
  border-left: 1px solid #e2e8f0;
  padding-left: 16px;
  align-self: stretch;
}

div.headerContent div.midr div.fith {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

div.headerContent div.midr div.fith div.formation {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

div.headerContent div.midr div.fith div.solde-card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 170px;
  padding: 10px 14px 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #3b82f6;
  border-radius: 12px;
}

div.solde-card-txt {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1;
}

div.solde-card-txt span {
  text-align: left;
}

span.solde-card-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
  cursor: pointer;
}

button.solde-card-add {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  cursor: pointer;
  transition: background .15s, transform .15s;
}

button.solde-card-add:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

span.solde-card-value {
  font-size: 18px;
  font-weight: 800;
  color: #1a1f2e;
  cursor: pointer;
}


/* ===================== COLONNE DROITE (profil) ===================== */
div.headerContent div.right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

div.pageInfo {
  display: flex;
  align-items: center;
  gap: 8px;
  height: auto;
  position: static;
  margin-top: 0;
  margin-top: 1rem;
}

div.pageInfo div.btnLeft {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

div.pageInfo img.goProfile {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

/* ===================== BOUTONS GÉNÉRAUX ===================== */
button.btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
  letter-spacing: .01em;
}

button.btn-primary {
  background: #3b82f6;
  color: #fff;
  border: none;
}
button.btn-primary:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59,130,246,.3);
}

button.btn-success {
  background: #1a9e6e;
  color: #fff;
  border: none;
}
button.btn-success:hover:not(:disabled) {
  background: #168a5f;
}

button.btn-danger {
  background: #fee2e2;
  color: #ef4444;
  border: 1px solid #fca5a5;
}
button.btn-danger:hover:not(:disabled) {
  background: #ef4444;
  color: #fff;
}

button.btn:disabled {
  opacity: .65;
  cursor: default;
}

button.boite {
  border-radius: 20px;
  font-size: 11px;
  padding: 4px 10px;
}

button.accActiv {
  margin-left: 0;
}

img.logoaac {
  width: 18px;
}

/* ===================== DROPDOWN PROFIL ===================== */
.dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

button.profileBtn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a9e6e, #0d7a54);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  transition: box-shadow .15s;
}
button.profileBtn:hover {
  box-shadow: 0 0 0 3px rgba(26,158,110,.2);
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  top: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,.1), 0 4px 12px rgba(0,0,0,.05);
  padding: 6px;
  min-width: 180px;
  z-index: 999;
  line-height: normal;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-content p {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
  padding: 6px 12px 8px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 4px;
  line-height: 1.4;
}

.dropdown-content a {
  color: #1a1f2e;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  transition: background .1s, color .1s;
  line-height: 1.4;
  cursor: pointer;
}

.dropdown-content a:hover {
  background: #f4f6f9;
  color: #3b82f6;
}

.dropdown-content a:last-child {
  color: #ef4444;
  font-weight: 600;
  border-top: 1px solid #e2e8f0;
  border-radius: 0;
  margin-top: 4px;
  padding-top: 10px;
}

.dropdown-content a:last-child:hover {
  background: #fee2e2;
  color: #ef4444;
}

/* ===================== MODALE SOLDE ===================== */
div.headSolde {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

div.headSolde h3 {
  font-size: 15px;
  font-weight: 700;
  color: #1a1f2e;
}

button.btnSwitchSolde {
  border-radius: 20px;
  font-size: 12px;
  margin-left: auto;
}

img.logoPaiement {
  width: 18px;
}

/* ===================== MOBILE — NAV BAS ===================== */
div.nav-mobile {
  display: none;
}

div.mobile-right {
  display: none;
}

div.mobileProg {
  display: none;
}

div.dropdownMob {
  display: none;
}

/* ===================== RESPONSIVE ===================== */
@media only screen and (min-width: 1400px) {

  div.headerContent div.left div.second {
    margin-left: 20px;
  }

  div.headerContent {
    flex-wrap: nowrap;
  }

  div.headerContent div.center div.third {
    margin-left: 20px;
  }

  div.headerContent div.center div.third div.progressBar {
    width: 220px;
  }

  div.headerContent div.dispoMobile {
    display: none;
  }

  div.mobileProg {
    display: none;
  }

  div.dropdownMob {
    display: none;
  }

  div.nav-mobile {
    display: none;
  }

  div.mobile-right {
    display: none;
  }
}

@media only screen and (min-width: 100px) and (max-width: 1400px) {

  div.headerContent div.left div.first,
  div.headerContent div.left div.second {
    display: block;
  }

  div.choix-header{
    display: none;
  }

  div.form-resa{
    display: none !important;
  }

  div.headerContent div.left div.resaSelect {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  div.headerContent div.left div.resaSelect select {
    width: 100%;
    margin-right: 0;
    margin-bottom: 0;
  }

  div.headerContent div.left div.resaSelect button.paramsweb {
    width: 100%;
    justify-content: center;
    border-radius: 10px;
  }

  div.nav-mobile {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0,0,0,.1);
    border-top: 1px solid #e2e8f0;
    z-index: 1000;
  }

  div.nav-mobile div.nav-content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
  }

  div.nav-mobile div.nav-content img {
    width: 22px;
    height: 22px;
  }

  div.nav-mobile div.nav-content span {
    font-size: 10px;
    color: #94a3b8;
    display: block;
    text-align: center;
  }

  div.nav-mobile div.nav-content span.active {
    color: #3b82f6;
    font-weight: 700;
  }

  div.nav-mobile div.nav-content div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 4px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background .1s;
  }

  div.nav-mobile div.nav-content div:active {
    background: #f4f6f9;
  }

  div.headerContent {
    flex-direction: column;
  }

  div.headerContent div.left {
    display: block;
    flex-direction: column;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,.06);
  }

  div.headerContent div.left div.titlePart span {
    color: #3b82f6;
    font-weight: 700;
  }

  div.headerContent div.left select {
    width: 100%;
    max-width: 100%;
    margin-right: 0;
  }

  div.headerContent div.midr {
    display: none;
    margin-left: 0;
    padding-left: 0;
    border-left: none;
  }

  div.headerContent div.right {
    display: none;
  }

  div.headerContent div.center {
    display: none;
    margin: auto;
  }

  div.bar {
    display: none;
  }



  div.mobileProg {
    display: none;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,.06);
    width: 100%;
    margin: auto;
  }

  div.bar{
    display: none!important; 
  }

  div.mobileProg span {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .06em;
    color: #3b82f6;
  }

  div.prog-hours {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 0;
    padding: 8px 0;
    border-top: 1px solid #f0f0f0;
    font-size: 13px;
  }

  div.prog-hours:first-of-type {
    border-top: none;
    padding-top: 4px;
  }

  div.prog-hours span.hours-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: none;
    letter-spacing: normal;
  }

  div.prog-hours span.hours-value {
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
  }

  div.mobileProg button {
    margin: 6px 4px;
  }

  div.mobileProg div.heures-block {
    margin: 10px 0;
    padding-top: 10px;
    border-top: 1px solid #e2e8f0;
  }

  div.mobileProg div.heure-equation {
    flex-wrap: wrap;
    justify-content: center;
  }

  div.mobile-right {
    display: none;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,.06);
    width: 100%;
  }

  div.mobile-right div.title-mobile {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .06em;
    color: #3b82f6;
    margin-bottom: 10px;
  }

  div.mobile-right div.content-mobile {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  div.mobile-right button.params img {
    width: 20px;
    height: 20px;
  }

  div.dispoMobile {
    display: block;
  }

  div.dispoMobile button.valid-mobile {
    margin-top: 10px;
    margin-bottom: 6px;
  }

  p.mobile-dispo-hint {
    font-size: 12px;
    color: #3b82f6;
    margin: 8px 0 4px;
    line-height: 1.5;
  }

  div.dropdownMob {
    display: none;
  }

  div.dropdown-contentMob {
    display: none;
    position: absolute;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    min-width: 180px;
    right: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,.1);
    z-index: 100;
    padding: 6px;
    line-height: normal;
  }

  div.dropdown-contentMob a {
    color: #1a1f2e;
    padding: 8px 12px;
    text-decoration: none;
    display: block;
    font-size: 13px;
    border-radius: 8px;
    transition: background .1s;
    line-height: 1.4;
  }

  div.dropdown-contentMob a:hover {
    background: #f4f6f9;
    color: #3b82f6;
  }

  p.aacTextDate {
    display: none;
  }
}

/* DATATABLE STYLE */

.rdvPage .table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 12px;
}

.rdvPage .table-wrap--modal {
  max-height: 48vh;
  overflow-y: auto;
}

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}



/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

/* ===== Dialog créditer solde ===== */
.credit-dialog {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 4px 0 8px;
}

.credit-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.credit-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.credit-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.credit-input-wrap {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.credit-input-wrap:focus-within {
  border-color: #3b82f6;
}

.credit-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 14px;
  font-size: 15px;
  font-family: inherit;
  color: #1a1f2e;
  background: transparent;
}

.credit-suffix {
  padding: 10px 14px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  background: #f8fafc;
  border-left: 1.5px solid #e2e8f0;
}

.credit-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.credit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}
.credit-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.credit-btn--ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}
.credit-btn--ghost:hover { background: #f8fafc; }

.credit-btn--primary {
  background: #3b82f6;
  color: #fff;
}
.credit-btn--primary:hover:not(:disabled) { background: #2563eb; }

/* ===== Dialog Permis Accéléré ===== */
.acc-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0 4px;
  text-align: center;
}

.acc-icon-wrap {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(251, 191, 36, 0.35);
}

.acc-dialog-icon {
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
}

.acc-price-badge {
  font-size: 36px;
  font-weight: 800;
  color: #1a1f2e;
  line-height: 1;
}

.acc-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  max-width: 280px;
  line-height: 1.55;
}

.acc-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff5f5;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 12px 14px;
  color: #b91c1c;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}

.acc-warning svg {
  flex-shrink: 0;
  margin-top: 1px;
}

.acc-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: 100%;
  margin-top: 4px;
}

/* ===== Dialog Simu Info ===== */
.simu-info-icon {
  font-size: 40px;
  line-height: 1;
}

/* ===== Dialog Simu Warning ===== */
.simu-warn-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 8px 0 4px;
  text-align: center;
}

.simu-warn-icon {
  font-size: 40px;
  line-height: 1;
}

.simu-warn-text {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
  max-width: 300px;
}

.simu-warn-list {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
  padding: 0 0 0 20px;
  max-width: 300px;
  text-align: left;
}

.simu-warn-actions {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 4px;
}

</style>

<style>
/* Non-scoped : le Dialog PrimeVue téléporte son contenu vers document.body,
   ce qui échappe au CSS "scoped" ci-dessus même avec :deep(). */
.heures-prog-table.p-datatable {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

.heures-prog-table .p-datatable-thead > tr > th {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

.heures-prog-table .p-datatable-tbody > tr {
  background: #ffffff;
  transition: background 0.15s;
}

.heures-prog-table .p-datatable-tbody > tr:hover {
  background: #f9fafb;
}

.heures-prog-table .p-datatable-tbody > tr > td {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

.heures-prog-table .p-datatable-tbody > tr > td:nth-child(2) {
  font-weight: 700;
  color: #1a1f2e;
}

.heures-prog-table span.type-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: #e0e7ff;
  color: #4338ca;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.heures-prog-table span.mono-name {
  font-weight: 600;
  color: #1a1f2e;
}

.heures-prog-empty {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 14px;
}

.heures-prog-table .p-paginator {
  background: #ffffff;
  border-top: 1px solid #f3f4f6;
}
</style>